module.exports = __webpack_public_path__ + "img/widgetcatalog-1.a70acaae.jpg";